import { asScaled } from '../utils';
const reviewLayout = {
    // 非nps默认图标边长
    sideLength: 28,
    // 非nps默认图标间距
    spacing: 12,
    // 非nps默认小图标边长
    smallSideLength: 14,
    // 非nps默认小图标间距
    smallSpacing: 2,
    // nps未选中图标边长
    npsSideLength: 24,
    // nps选中图标边长
    npsActiveSideLength: 26,
    // nps选中图标top、left偏移量
    npsPosition: -1
};
const reviewLayoutScaled = asScaled(reviewLayout);
export const review = {
    scaled: reviewLayoutScaled,
    unscaled: reviewLayout
};
